import { StaffDetail } from './StaffDetail';
import StaffFilter from './StaffFilter';

const Staff = {
  Filter: StaffFilter,
  Detail: StaffDetail
};

export default Staff;
